<template>
  <a
    role="button"
    ref="addToWishList"
    class="btn btn-sm add-to-wish-list d-flex justify-content-center align-items-center"
    :class="hideText ? '' : 'w-100'"
    :title="tooltipText"
    @click.prevent="switchState()"
    tabindex="0"
  >
    <span
      v-if="!hideText"
      class="mr-2 mr-md-3 text-nowrap"
    >{{ $translate("Ceres::Template.singleItemWishList") }}</span>
    <icon
      :icon="isVariationInWishList ? 'heart' : (hideText ? 'heart fal' : 'heart far')"
      class="default-float"
      :class="{'text-appearance text-danger': isVariationInWishList}"
      :loading="isLoading"
    />
  </a>
</template>

<script>
import { mapState } from 'vuex'

export default {

    name: 'AddToWishListButton',

    props: {
        variationId: {
            type: Number,
            required: true
        },
        itemId: {
            type: Number,
            required: true
        },
        hideText: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            isLoading: false
        }
    },

    computed:
            {
                tooltipText () {
                    return this.$translate(
                        'Ceres::Template.' + (this.isVariationInWishList ? 'singleItemWishListRemove' : 'singleItemWishListAdd')
                    )
                },
                isVariationInWishList () {
                    return this.wishListIds.includes(this.currentVariationId)
                },

                currentVariationId () {
                    return this.variationId ? this.variationId : this.currentVariationVariationId
                },

                currentVariationVariationId () {
                    const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`]

                    if (!currentVariation) {
                        return null
                    }

                    return currentVariation && currentVariation.variation && currentVariation.variation.id
                },
                ...mapState({
                    wishListIds: state => state.wishList.wishListIds
                })
            },
    methods:
            {
                switchState () {
                    if (this.isVariationInWishList) {
                        this.removeFromWishList()
                    } else {
                        this.addToWishList()
                    }
                    this.$refs.addToWishList.blur()
                },

                addToWishList () {
                    if (!this.isLoading) {
                        this.isLoading = true
                        this.$store.dispatch('addToWishList', parseInt(this.currentVariationId)).then(
                            response => {
                                this.isLoading = false
                                this.$emit('item-added')
                            },
                            error => {
                                this.isLoading = false
                                console.error(error)
                            })
                    }
                },

                removeFromWishList () {
                    if (!this.isLoading) {
                        this.isLoading = true
                        this.$store.dispatch('removeWishListItem', { id: parseInt(this.currentVariationId) }).then(response => {
                            this.isLoading = false
                        },
                        error => {
                            this.isLoading = false
                            console.error(error)
                        })
                    }
                }
            }
}

</script>
